import { getImageKitUrl } from "utils/cdn";
import { StepCardData, BenefitCardData, TestimonialCardData } from "./types";
import { RemoteImages } from "constants/images";

export const stepsData: StepCardData[] = [
    {
        id: "step-1",
        step: "1.",
        description: "Refer a Rider",
        icon: getImageKitUrl(RemoteImages.handshakeIcon, { width: 200 }),
    },
    {
        id: "step-2",
        step: "2.",
        description: "Get Swiggy/Instamart Delivery Partner App Downloaded",
        icon: getImageKitUrl(RemoteImages.foodImIcon, { width: 200 }),
    },
    {
        id: "step-3",
        step: "3.",
        description: "Rider Completes Orders",
        icon: getImageKitUrl(RemoteImages.bagIcon, { width: 200 }),
    },
    {
        id: "step-4",
        step: "4.",
        description: "You Earn Bonus",
        icon: getImageKitUrl(RemoteImages.moneyIcon, { width: 200 }),
    },
];

export const benefitsData: BenefitCardData[] = [
    {
        id: "benefit-1",
        title: "Weekly",
        subtitle: "money credit",
        icon: "/images/calendar_icon.png",
    },
    {
        id: "benefit-2",
        title: "Easy",
        subtitle: "Process",
        icon: "/images/easy_process_icon.png",
    },
];

export const testimonialsData: TestimonialCardData[] = [
    {
        id: "testimonial-1",
        name: "Jyoti Sharma",
        businessName: "Twist of Tadka",
        profileImage: "/images/influencer-profile-7f80f8.png",
        testimonial:
            "Being the owner of a restaurant was my dream since I was a little girl. I have successfully started my restaurant callec\n\nTwist of Tadka' in Bhopal. Since InCred's loans are sanctioned and disbursed digitally I got my loan approve in only as hours. used the loan amount to renovate my",
    },
    {
        id: "testimonial-2",
        name: "Jyoti Sharma",
        businessName: "Twist of Tadka",
        profileImage: "/images/influencer-profile-7f80f8.png",
        testimonial:
            "Being the owner of a restaurant was my dream since I was a little girl. I have successfully started my restaurant callec\n\nTwist of Tadka' in Bhopal. Since InCred's loans are sanctioned and disbursed digitally I got my loan approve in only as hours. used the loan amount to renovate my",
    },
];
